module.exports = __webpack_public_path__ + "static/img/AI审核_文字_png@2x.fa5eb490.png";